import React from "react";

const NomasseCreatePage = () => {
  return <div>NomasseCreatePage</div>;
};

export default NomasseCreatePage;
